import endpoints from '@/services/http/endpoints'
import http from '@/services/http/index'

import fixture from '@/services/http/fixtures/fixture'
import guardianConsent from '@/services/http/fixtures/guardianConsent'

export default {
  getByType(payload, assigned = false) {
    let endpoint = assigned ? 'documentAssigned' : 'document'
    if (payload?.isCoordinator && payload?.documentType === 'coordinator_questionnaire') {
      endpoint = 'documentAdditionalView'
    }
    return fixture(guardianConsent, () => http.get(endpoints.get(endpoint, { ...payload })))
  },
  post(payload, assigned = false) {
    const endpoint = assigned ? 'documentAssigned' : 'document'
    return http.post(endpoints.get(endpoint, { ...payload }), payload.data)
  },
  /**
   * Updates a child document.
   * @param {Object} payload - The payload for the update request.
   * @param {string} [method='post'] - The HTTP method to use for the update request.
   * @returns {Promise} - A promise that resolves with the response data.
   */
  update(payload, method = 'post') {
    const endpoint = 'documentUpdate'
    return http[method](endpoints.get(endpoint, { ...payload }), payload.data)
  },
  accept(payload) {
    return http.post(endpoints.get('acceptDocument', { ...payload }))
  },
  /**
   * Updates a child document with privileged access.
   * @param {Object} payload - The payload containing the data to be updated.
   * @param {string} [method='post'] - The HTTP method to be used for the update request.
   * @returns {Promise} - A promise that resolves with the updated child document.
   */
  privilegedUpdate(payload, method = 'post') {
    return http[method](endpoints.get('privilegedUpdate', { ...payload }), payload.data)
  },
  fetchDrawingFileBySize(payload, assigned = false) {
    const endpoint = assigned ? 'drawingBySizeAssigned' : 'drawingBySize'
    return http.get(endpoints.get(endpoint, { ...payload }), {
      responseType: 'blob'
    })
  },
  sendBack(payload) {
    return http.post(endpoints.get('sendBack', { ...payload }), payload.data)
  },
  sendToAccept(payload, assigned = false) {
    const endpoint = assigned ? 'sendToAcceptAssigned' : 'sendToAccept'
    return http.post(endpoints.get(endpoint, { ...payload }), payload.data)
  },
  correction(payload, assigned = false, method = 'post') {
    const endpoint = assigned ? 'correctionAssigned' : 'correction'
    return http[method](endpoints.get(endpoint, { ...payload }), payload.data)
  },
  addComment(payload, assigned = false) {
    const endpoint = assigned ? 'commentAssigned' : 'comment'
    return http.post(endpoints.get(endpoint, { ...payload }), payload.data)
  }
}
